import { useMutation } from '@tanstack/react-query'
import axios from 'axios'

export const AdminTasksEndpoints = {
  getNextTask: '/tasks/next',
}

export const useGetNextTask = () => {
  return useMutation({
    mutationFn: async ({
      program_id,
      validate_assigned_task,
    }: {
      program_id: number
      validate_assigned_task: number
    }) => {
      const params = new URLSearchParams()

      params.append('validate_assigned_task', validate_assigned_task.toString())
      params.append('program_id', program_id.toString())

      const response = await axios.get(
        `${AdminTasksEndpoints.getNextTask}?${params.toString()}`
      )
      return response.data
    },
  })
}
